<template>
  <div class="content-school-wrap">
    <div class="content-school">
      <img
        class="close-btn"
        @click="clickBtn('cancel')"
        src="../../assets/icons/close-btn.png"
        alt=""
      />
      <div class="title">请确认所属学校</div>
      <div class="item-wrap">
        <div
          class="school-item"
          :class="curSelected === index ? 'selected' : ''"
          v-for="(item, index) in schoolList"
          :key="index"
          @click="curSelected = index"
        >
          <span>{{ item.schoolName }}</span>
          <img
            v-show="curSelected === index"
            src="../../assets/icons/xuanzhong.svg"
            alt=""
          />
        </div>
      </div>
      <div class="btns">
        <button class="btns-confirm" @click="clickBtn('confirm')">确定</button>
      </div>
    </div>
  </div>
</template>
<script>
import { encryptDes, decryptDes } from "@/utils/des";
import { parseUrlParam } from "@/utils/common";
export default {
  data() {
    return {
      dialogFormVisible: true,
      schoolList: [],
      curSelected: 0,
      code: null
    };
  },
  created() {
    // 竖版以720屏幕适配
    var deviceWidth;
    setHtmlFontSize();
    if (window.addEventListener) {
      window.addEventListener(
        "resize",
        function() {
          setHtmlFontSize();
        },
        false
      );
    }
    function setHtmlFontSize() {
      deviceWidth = document.documentElement.clientWidth;
      document.getElementsByTagName("html")[0].style.cssText =
        "font-size:" + deviceWidth / 7.2 + "px";
    }
    // 获取参数
    let obj = parseUrlParam();
    let schools = decryptDes(
      decodeURIComponent(obj.otherSign),
      "M2Q0YjkyYmRiNDA4N2JmZWM1YmNlODIxNmJhMzI1MTA"
    );
    this.schoolList = JSON.parse(schools || "{}").schoolList;
    this.code = obj.code;
  },
  methods: {
    clickBtn(type) {
      let enSelectSchool = "";
      if (this.schoolList && this.schoolList.length > 0) {
        let selectSchool = {
          schoolId: this.schoolList[this.curSelected].schoolId,
          projectId: this.schoolList[this.curSelected].projectId
        };
        enSelectSchool = encryptDes(
          JSON.stringify(selectSchool),
          "M2Q0YjkyYmRiNDA4N2JmZWM1YmNlODIxNmJhMzI1MTA"
        );
      }
      let sendObj = {
        result: type === "cancel" || !enSelectSchool ? 0 : 1, // result 1确定 0取消 其他待定义
        msg: type === "cancel" || !enSelectSchool ? "取消" : "确定",
        data: {
          code: this.code,
          signMessage: type === "cancel" ? "" : enSelectSchool
        }
      };
      alert(JSON.stringify(sendObj));
    }
  }
};
</script>
<style>
#app {
  background: transparent;
}
</style>
<style lang="scss" scoped>
.content-school-wrap {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
}
.content-school {
  padding: 0.38rem 0.38rem 0.4rem 0.5rem;
  width: 6rem;
  height: 6.75rem;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 0.1rem;
  .close-btn {
    position: absolute;
    right: 0;
    top: -0.74rem;
    width: 0.42rem;
    height: 0.42rem;
  }
  .title {
    font-size: 0.3rem;
    font-weight: 500;
    color: #222222;
    margin-bottom: 0.04rem;
    line-height: 0.42rem;
  }
  .item-wrap {
    height: calc(100% - 1.97rem);
    // height: 252px;
    overflow-y: auto;
    padding-right: 0.12rem;
  }
  .school-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0.9rem;
    // background: #f5f6f8;
    border-radius: 0.04rem;
    box-sizing: border-box;
    margin-top: 0.3rem;
    padding: 0 0.24rem 0 0.36rem;
    font-size: 0.3rem;
    color: #666666;
    border: 2px solid #cccccc;
    background: #fff;
    img {
      width: 0.32rem;
      height: 0.32rem;
    }
  }
  .selected {
    border: 2px solid #49acee;
    color: #49acee;
    background: #fff;
  }
  .btns {
    margin-top: 0.4rem;
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0.4rem;
    width: calc(100% - 0.63rem);
    box-sizing: border-box;
    margin-left: -0.18rem;
    &-confirm {
      width: 100%;
      height: 0.8rem;
      text-align: center;
      line-height: 0.8rem;
      outline: none;
      font-size: 0.3rem;
      font-weight: 500;
      box-sizing: border-box;
      border-radius: 0.08rem;
      color: #fff;
      background: #4aacee;
      border: none;
    }
  }
}
</style>
